import React, { useEffect, useState } from "react";
import classes from "./Banner1.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import Banner from "../Banner/Banner";

const Banner1 = ({ bannerData }: { bannerData: any }) => {
  const isMobile = useIsMobile(1100);

  const [bannerFeatures, setBannerFeatures] = useState<any>([]);

  useEffect(() => {
    let tempBannerFeatures = [bannerData?.banner_feature_1 ?? {}, bannerData?.banner_feature_2 ?? {}];

    setBannerFeatures(tempBannerFeatures ?? []);
  }, [bannerData]);

  return (
    <Banner bannerData={bannerData ?? {}} bannerStyles={isMobile ? {} : { width: "calc(100vw - 429px - 90px" }} bgInverted={false}>
      <div className={classes["banner-container"]}>
        <div className={classes["banner-image-container"]}>
          <CustomImage src={"/images/man_with_foldedhands.png"} alt={"banner-image"} layout="fill" objectFit="cover" />
        </div>

        {isMobile ? (
          <div className={classes["banner-content-container"]}>
            <h2 className={classes["banner-title"]}>{bannerData?.title ?? ""}</h2>
            <div className={classes["banner-features-container"]}>
              {bannerFeatures.length > 0 &&
                bannerFeatures.map((feature: any, index: number) =>
                  feature.title && feature.subtitle ? (
                    <div className={classes["banner-feature"]} key={index}>
                      <div className={classes["banner-feature-icon"]}>
                        <CustomImage src="/icons/target_icon.svg" height={40} width={40} alt={"banner-feature-icon"} />
                      </div>
                      <div className={classes["banner-feature-info"]}>
                        <h3>{feature.title}</h3>
                        <p>{feature.subtitle}</p>
                      </div>
                    </div>
                  ) : (
                    <></>
                  ),
                )}
            </div>

            <button className={`${classes["banner-btn"]} ${isFrappeOrJotFormClass(bannerData?.enquireForm?.url)}`}>{bannerData?.btnLabel ?? ""}</button>
          </div>
        ) : (
          <div className={classes["banner-content-container"]}>
            <h2 className={classes["banner-title"]}>{bannerData?.title ?? ""}</h2>
            <div className={classes["banner-features-container"]}>
              {bannerFeatures.map((feature: any, index: number) =>
                feature.title && feature.subtitle ? (
                  <div className={classes["banner-feature"]} key={index}>
                    <div className={classes["banner-feature-icon"]}>
                      <CustomImage src="/icons/target_icon.svg" height={40} width={40} alt={"banner-feature-icon"} />
                    </div>
                    <div className={classes["banner-feature-info"]}>
                      <h3>{feature.title}</h3>
                      <p>{feature.subtitle}</p>
                    </div>
                  </div>
                ) : (
                  <></>
                ),
              )}
            </div>
            <button className={`${classes["banner-btn"]} ${isFrappeOrJotFormClass(bannerData?.enquireForm?.url)}`}>{bannerData?.btnLabel ?? ""}</button>
          </div>
        )}

        <div className={classes["banner-kc-union-container"]}>
          {!isMobile && <CustomImage src="/icons/kc_union.svg" height={"228px"} width={"397px"} alt={"banner-kc-union-icon"} />}
        </div>
      </div>
    </Banner>
  );
};

export default Banner1;
